module.exports = __webpack_public_path__ + "static/img/confetti_right@3x.9893c05.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/misc/3x/confetti_right@3x.png
// module id = j/o8
// module chunks = 1